<div v-if="shouldRenderConfig" ref="preview2D" v-bind:class="[getClassName + 'Container', visible]">
    <img :src="getPreview2D" />
</div>

